import apiClient from '@/services/api-client';

export const ocrTnCinFull = async (firstDocumentAsFile, secondDocumentAsFile) => {
  const formData = new FormData();
  formData.append('recto', firstDocumentAsFile);
  formData.append('verso', secondDocumentAsFile);

  const response = await apiClient.post('/ocr/ocr-cin-full', formData, {
    headers: {'Content-Type': 'multipart/form-data'},
  });

  return response.data;
};


export const ocrPassport = async (file) => {
  const formData = new FormData();
  formData.append('file', file);

  const response = await apiClient.post('/ocr/ocr-passport', formData, {
    headers: {'Content-Type': 'multipart/form-data'},
  });

  return response.data;
};


export const ocrCinEuro = async (firstDocumentAsFile) => {
  const formData = new FormData();
  formData.append('file', firstDocumentAsFile);

  const response = await apiClient.post('/ocr/ocr-cin-euro', formData, {
    headers: {'Content-Type': 'multipart/form-data'},
  });

  return response.data;
};




7
/*
export const extractPaperCorners = async (file) => {
  const formData = new FormData();
  formData.append('file', file);

  const response = await apiClient.post('/ocr/extract-corners', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });

  return response.data;
};


export const warpPerspective = async (file, corners) => {
  const formData = new FormData();
  formData.append('file', file);

  const response = await apiClient.post('/ocr/warp-perspective', formData, {
    headers: {'Content-Type': 'multipart/form-data'},
    params : {corners:corners},
    responseType: "arraybuffer" 
  });

  return response.data;
};

export const ocrCinRecto = async (file) => {
  const formData = new FormData();
  formData.append('file', file);

  const response = await apiClient.post('/ocr/ocr-cin-recto', formData, {
    headers: {'Content-Type': 'multipart/form-data'},
  });

  return response.data;
};

export const ocrCinVerso = async (file) => {
  const formData = new FormData();
  formData.append('file', file);

  const response = await apiClient.post('/ocr/ocr-cin-verso', formData, {
    headers: {'Content-Type': 'multipart/form-data'},
  });

  return response.data;
};

*/
